/** Lifecycle states of a background job (`GET jobs` auto-fails RUNNING jobs past the server timeout). */
export var JobStatus;
(function (JobStatus) {
    JobStatus["Running"] = "RUNNING";
    JobStatus["Succeeded"] = "SUCCEEDED";
    JobStatus["Failed"] = "FAILED";
})(JobStatus || (JobStatus = {}));
/** First-level job → tool discriminator (`detect_shapes` further splits on the result's `shape_type`). */
export var JobKind;
(function (JobKind) {
    JobKind["CrackDetection"] = "crack_detection";
    JobKind["ChalkDetection"] = "chalk_detection";
    JobKind["SavePolylinesWithWidthDetection"] = "save_polylines_with_width_detection";
    JobKind["DetectShapes"] = "detect_shapes";
    JobKind["EvaluateDistancesOnGrid"] = "evaluate_distances_on_grid";
    JobKind["DetectPolygonsVolume"] = "detect_polygons_volume";
    JobKind["ReevaluateVolumeAndGrid"] = "reevaluate_volume_and_grid";
    JobKind["EvaluateDepths"] = "evaluate_depths";
})(JobKind || (JobKind = {}));
